import { Tooltip } from "antd";
import AdvanceTable from "modules/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "modules/common/advance-table/AdvanceTablePagination";
import AdvanceTableSearchBox from "modules/common/advance-table/AdvanceTableSearchBox";
import AdvanceTableWrapper from "modules/common/advance-table/AdvanceTableWrapper";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function CommunityTable({ data }) {
  const navigate = useNavigate();

  const navigateToCommunity = (id, name, stats) => {
    navigate(`/community-details?id=${id}&name=${name}&count=${stats}`);
  };

  const columns = [
    {
      accessor: "name",
      Header: "Name",
      headerProps: { className: "text-900" },
      Cell: ({ row }) => (
        <div
          className="cursor-pointer text-primary"
          onClick={() => {
            navigateToCommunity(row.original.id, row.original.name, row.original.stats);
          }}
        >
          <Tooltip title="Click to navigate">{row.original.name}</Tooltip>
        </div>
      ),
    },
    {
      accessor: "stats",
      Header: "Stats",
      headerProps: { className: "text-900" },
    },
  ];

  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={10}
    >
      <Row className="flex-end-center mb-3">
        <Col xs="auto" sm={6} lg={4}>
          <AdvanceTableSearchBox table />
        </Col>
      </Row>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: "fs-10 mb-0 overflow-hidden",
        }}
      />
      <div className="mt-3">
        <AdvanceTablePagination table className="pagination-sm" />
      </div>
    </AdvanceTableWrapper>
  );
}

export default CommunityTable;
